import { END_POINT } from "@constants/api.constants";
import { checkForExpiredToken } from "@screens/system/settings/setting-list/setting.list.service";
import { store } from "@src/store";

const { INVENTORY_FILE_UPLOAD_LIST, INVENTORY_FILE_UPLOAD_DELETE, INVENTORY_ITEMS_UPLOAD } = END_POINT;

export const getFileUploadsApi = async ({ orderBy, sortBy, skip, limit, filters }) => {
  return await fetch(
    `${INVENTORY_FILE_UPLOAD_LIST}?sort_by=${sortBy}&order_by=${orderBy}&skip=${skip}&limit=${limit}${filters}`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
        token: store.getState().app?.token,
      },
    }
  )
    .then((res) => res.json())
    .then((response) => {
      if (response.status)
        return {
          status: true,
          data: response.data.list,
          totalCount: response.data.total_count,
        };
      else {
        checkForExpiredToken(response.message);
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const deleteFileUploadApi = async (ids) => {
  return await fetch(INVENTORY_FILE_UPLOAD_DELETE, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify({ ids }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return {
          status: true,
          data: data.data.list,
          totalCount: data.data.total_count,
        };
      else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const uploadFileApi = async (payload) => {
  const formData = new FormData();
  formData.append("category_id", payload.category_id);
  formData.append("file", payload.file);

  return await fetch(INVENTORY_ITEMS_UPLOAD, {
    method: "POST",
    headers: {
      token: store.getState().app.token,
    },
    body: formData
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) return { status: true, data: data.data };
      else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};